import { createSlice } from "@reduxjs/toolkit";
import {
  getNotifications,
  addNewNotification,
  updateNotification,
  deleteNotification,
} from "./thunk";

export const initialState = {
  notifications: [],
  notificationsTotal: 0,
  notificationsPage: 1,
  notificationsHasMore: false,
  error: {},
};

const notificationsSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      const { notifications, total, page, hasMore, append } = action.payload;
      state.notifications = append
        ? [...state.notifications, ...(notifications || [])]
        : (notifications || []);
      state.notificationsTotal = total ?? state.notificationsTotal;
      state.notificationsPage = page ?? 1;
      state.notificationsHasMore = hasMore ?? false;
      state.isNotificationsFailed = false;
      state.isNotificationsSuccess = true;
    });

    builder.addCase(getNotifications.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isNotificationsFailed = true;
      state.isNotificationsSuccess = false;
    });

    builder.addCase(addNewNotification.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isNotificationAdd = false;
      state.isNotificationAddFail = true;
    });

    builder.addCase(updateNotification.fulfilled, (state, action) => {
      // action.payload нь { message, matchedCount, modifiedCount } байх боломжтой
      // Хэрэв backend нь updated notifications list буцаавал, түүнийг map хийх боломжтой
      // Жишээ: updated notifications list буцаахгүй бол state-ийг зөвхөн isRead-г шинэчилнэ
      if (Array.isArray(state.notifications)) {
        const ids = (action.meta.arg.ids || []).map(String);
        const userId = String(action.meta.arg.userId || "");
        state.notifications = state.notifications.map((notification) => {
          const isUpdated = ids.includes(String(notification._id));
          if (isUpdated) {
            return {
              ...notification,
              recipients: notification.recipients.map((r) =>
                String(r.userId) === userId ? { ...r, isRead: true } : r
              ),
            };
          }
          return notification;
        });
      }

      state.isNotificationUpdate = true;
      state.isNotificationUpdateFail = false;
    });

    builder.addCase(updateNotification.rejected, (state, action) => {
      state.error = action.payload || action.error.message || null;
      state.isNotificationUpdate = false;
      state.isNotificationUpdateFail = true;
    });

    builder.addCase(deleteNotification.fulfilled, (state, action) => {
      state.notifications = (state.notifications || []).filter(
        (notification) =>
          notification._id.toString() !== action.payload.notification.toString()
      );
      state.isNotificationDelete = true;
      state.isNotificationDeleteFail = false;
    });

    builder.addCase(deleteNotification.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isNotificationDelete = false;
      state.isNotificationDeleteFail = true;
    });
  },
});

export default notificationsSlice.reducer;
